<template>
  <v-menu offset-y
          :close-on-content-click="false"
          :nudge-width="100"
          v-model="menu"
          transition="slide-y-transition">

    <v-avatar class="primary"
              slot="activator"
              size=30>
      <v-icon dark>language</v-icon>
    </v-avatar>

    <v-card>
      <v-list>
        <v-list-tile v-for="code in languages"
                     :key="code"
                     @click="changeLanguage(code, false)"
                     v-if="code !== localeSelected">

          <v-list-tile-avatar size="20"
                              v-if="showFlagCountry">
            <img :src="`/static/img/${code}.png`"
                 alt="">
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-sub-title>{{ $t(`global_lang_${code}`) }}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import store from '@/store';
import { EventBus } from '@/services/eventBus';
import keys from '@/store/keys';

export default {
  name: 'change-language-dropdown',
  components: {},
  props: ['showFlagCountry'],
  data() {
    return {
      localeSelected: this.$i18n.locale,
      flagCountry: '/static/img/es-ES.png',
      countryI18n: 'global_lang_es-ES',
      buttonType: this.showFlagCountry ? 'text' : 'default',
      languages: ['ca-ES', 'en-GB', 'es-ES']
    };
  },
  created() {
    this.updateLanguages();
    this.changeLanguage(this.$i18n.locale, true);

    EventBus.$on(keys.eventOnApiSelected, this.updateLanguages);
  },
  destroyed() {
    EventBus.$off(keys.eventOnApiSelected, this.updateLanguages);
  },
  methods: {
    updateLanguages() {
      let languageSelected = store.state.langSelected;
      this.languages = store.state.countryConstantsSelected.langs;
      this.flagCountry = `/static/img/${languageSelected.langIso}.png`;
      this.countryI18n = `global_lang_${languageSelected.langIso}`;

      this.languages = store.state.countryConstantsSelected.langs;

      this.localeSelected = this.languages[0];

      this.changeLanguage(this.localeSelected, true);
    },
    changeLanguage(locale, init) {
      this.$i18n.locale = locale;
      this.localeSelected = locale;
      this.flagCountry = `/static/img/${locale}.png`;
      this.countryI18n = `global_lang_${locale}`;
      store.commit('CHANGE_LANG_SELECTED', { langSelected: this.localeSelected, init: init });
    }
  }
};
</script>

<style lang="scss" scoped>
.v-list__tile__avatar {
  min-width: 36px;
}
</style>



// WEBPACK FOOTER //
// src/components/commons/ChangeLanguageDropdown.vue